import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  color: #0384ac;

  svg {
    margin-right: 5px;
    font-size: 24px;
  }
`;

export const Text = styled.p`
  ${(props) =>
    props.bold &&
    `
    font-weight: bold;
  `}
  font-size: 14px;
`;

export const DateText = styled.p`
  font-size: 14px;
  margin-left: 4px;
`;
